function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import store from '@/store';
import router from '@/router';
import axios from 'axios';
import qs from 'qs';
import util from '@/libs/util';
import Setting from '@/setting.ht';
import { Message, Notice, Modal, Spin } from 'view-design';
var isRelogin = true; // 创建一个错误

function errorCreate(msg) {
  var err = new Error(msg);
  errorLog(err); // throw err; // 这里不能throw异常，否则不会进入接口的then方法
} // 记录和显示错误


function errorLog(err) {
  // 添加到日志
  store.dispatch('admin/log/push', {
    message: '数据请求异常',
    type: 'error',
    meta: {
      error: err
    }
  }); // 打印到控制台

  if (process.env.NODE_ENV === 'development') {
    util.log.error('>>>>>> Error >>>>>>');
  } // 显示提示，可配置使用 iView 的 $Message 还是 $Notice 组件来显示


  if (Setting.errorModalType === 'Message') {
    setTimeout(function () {
      Message.error({
        content: err.message,
        duration: Setting.modalDuration
      });
    }, 300);
  } else if (Setting.errorModalType === 'Notice') {
    if (process.env.NODE_ENV == 'development') {
      setTimeout(function () {
        Notice.error({
          title: '提示',
          desc: err.message,
          duration: Setting.modalDuration
        });
      }, 300);
    }
  }
} // 创建一个 axios 实例


var service = axios.create({
  baseURL: Setting.apiBaseURL,
  timeout: 1000 * 50 // 请求超时时间

}); // 请求拦截器

service.interceptors.request.use(function (config) {
  var authToken = util.cookies.get('auth-token');
  config.headers['auth-token'] = authToken && authToken !== '' ? authToken : '123';

  if (config.contentType === 'form' || config.contentType === 'notice') {
    config.data = qs.stringify(config.data);
    config.headers['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
  } else {
    config.headers['Content-Type'] = 'application/json;charset=UTF-8';
  }

  return config;
}, function (error) {
  Promise.reject(error);
}); // 响应拦截器

service.interceptors.response.use(function (response) {
  var result;

  switch (response.status) {
    case 200:
      if (response.headers.licensemsg) {
        Modal.warning({
          title: '<p stype="font-size:16px;">温馨提示</p>',
          content: "<p style=\"font-size:14px;color:#ED4014;\">\u60A8\u7684\u7CFB\u7EDF\u8FD8\u5269".concat(response.headers.licensemsg, "\u5929\u8FC7\u671F!</p>")
        });
      }

      var data = response.data;

      if (response.headers['content-type'] == 'application/vnd.ms-excel;charset=UTF-8') {
        // 文件流下载
        result = data;
        return result;
      }

      if (data.code === CONSTANT.CODE_SUCCESS || data.code === CONSTANT.RESP_CODE_SUCCESS || data.code === CONSTANT.RESP_CODE_SUCCESS1) {
        if (data.data && (!data.data.respCode || data.data.respCode === CONSTANT.RESP_CODE_SUCCESS)) {
          result = data.data;
        } else if (!data.data) {
          result = true;
        } else {
          // 业务异常
          errorCreate(data.data.respDesc || '业务繁忙！');
          return Promise.reject({
            message: data.data.respDesc || '业务繁忙！'
          });
        }
      } else if (data.respCode === CONSTANT.RESP_CODE_SUCCESS || data.respCode === CONSTANT.CODE_SUCCESS) {
        result = data;
      } //  else if (typeof data === 'string') {
      //     errorCreate('CMS接口参数格式错误！');
      // }
      else {
        // 系统异常
        errorCreate(data.message || data.respDesc || '系统繁忙！');
        result = data;
        return Promise.reject(result);
      }

      break;
  } // 在这里对返回的数据进行处理


  return result;
}, function (error) {
  Spin.hide();

  if (error && error.response) {
    switch (error.response.status) {
      case 400:
        error.message = '400: 请求错误';
        break;

      case 401:
        error.message = '401: 未授权，请登录';
        var data = error.response.data;

        if (data.code !== CONSTANT.CODE_SUCCESS) {
          if (data.data && data.data.respCode === CONSTANT.RESP_CODE_AE401) {
            // 未登录或Token过期
            if (isRelogin) {
              isRelogin = false;
              localStorage.removeItem('cartNum'); // 清除用户登录信息

              sessionStorage.removeItem('userData'); // 清除用户登录信息

              sessionStorage.removeItem('auth'); // 清除用户登录信息

              sessionStorage.removeItem('uOrgList'); // 清除用户登录信息

              sessionStorage.removeItem('isChangeFlag'); // 清除用户登录信息

              util.cookies.remove('auth-token'); // 清除cookie登录票据

              Modal.info({
                title: '提示',
                content: '登录失效，请重新登录！',
                onOk: function onOk() {
                  router.push({
                    name: 'login',
                    query: {
                      redirect: encodeURIComponent(location.href)
                    }
                  });
                }
              }); // 重置计时器

              setTimeout(function () {
                isRelogin = true;
              }, 5000);
            }
          }
        }

        break;

      case 403:
        error.message = '403: 拒绝访问';
        break;

      case 404:
        error.message = "404: ".concat(error.response.config.url);
        break;

      case 408:
        error.message = '408: 请求超时';
        break;

      case 500:
        error.message = '500: 服务器内部错误';
        break;

      case 501:
        error.message = '501: 服务未实现';
        break;

      case 502:
        error.message = '502: 网关错误';
        break;

      case 503:
        error.message = '503: 服务不可用';
        break;

      case 504:
        error.message = '504: 网关超时';
        break;

      case 505:
        error.message = '505: HTTP版本不受支持';
        break;

      default:
        break;
    }
  } // errorLog(error); // 暂时屏蔽错误信息弹框


  return Promise.reject(error);
});
export default function request(url, option) {
  if (!tokenVerify()) return;
  if (!cartLimit(url)) return;
  var httpUrl = url.mock ? "".concat(CONFIG.MOCK_URL, "/").concat(url.control) : url.control;
  var reqUrl = '';

  if (option.method === 'GET' || option.method === 'DELETE') {
    var arr = [];

    _.forIn(option.data, function (val, key) {
      arr.push(key);
    }); // 参数不为空对象


    reqUrl = option.data && arr.length ? httpUrl + '?' + qs.stringify(option.data) : httpUrl;
  } else {
    reqUrl = httpUrl;
  }

  var defaultOptions = {
    method: 'POST',
    url: reqUrl,
    contentType: option.contentType
  };

  var newOptions = _objectSpread(_objectSpread({}, defaultOptions), option); // arms 上报


  var begin = Date.now();
  var traceId = window.__bl && __bl.getTraceId && __bl.getTraceId('EagleEye-TraceID') || "";
  var sid = window.__bl && __bl.getSessionId && __bl.getSessionId('EagleEye-SessionID') || '';
  traceId = traceId ? traceId["EagleEye-TraceID"] : '';
  sid = sid ? sid["EagleEye-SessionID"] : '';
  return service(_objectSpread({}, newOptions)).then(function (res) {
    try {
      var msg = "";

      try {
        msg = JSON.stringify(option.data);
      } catch (err) {
        msg = err.toString();
      }

      var time = Date.now() - begin;
      window.__bl && __bl.api(reqUrl, true, time, res.code, msg, begin, traceId, sid);
    } catch (err) {
      console.log(err);
    }

    return res;
  }).catch(function (err) {
    try {
      var msg = "";

      try {
        msg = JSON.stringify(option.data);
      } catch (err) {
        msg = err.toString();
      }

      var time = Date.now() - begin;
      window.__bl && __bl.api(reqUrl, false, time, 'ERROR', msg, begin, traceId, sid);
    } catch (err) {
      console.log(err);
    }

    return Promise.reject(err);
  });
}

var tokenVerify = function tokenVerify() {
  var authToken = util.cookies.get('auth-token');
  var expires = new Date(new Date().getTime() + (sessionStorage.getItem('expires') ? sessionStorage.getItem('expires') * 1 : CONSTANT.COOIKETIME));

  if (authToken) {
    // 重设过期时间
    util.cookies.set('auth-token', authToken, {
      expires: expires
    });
  }

  if (!authToken && store.getters['admin/global.v1/getIsLogin']) {
    // token失效且登录状态下拦截接口调用
    store.dispatch('admin/global.v1/changeLoginOut', {}, {
      root: true
    });
    return false;
  } else {
    return true;
  }
};

var cartLimit = function cartLimit(url) {
  // 购物车数量不能超过100种统一校验
  if ((url && url.control) === DYC_URL.m_addShoppingCart.control && store.getters['admin/global.v1/getNum'] >= 100) {
    Message.warning({
      title: '提示',
      content: '最多只能加入100种商品，请先前往购物车操作后在加购！',
      duration: Setting.modalDuration
    });
    return false;
  }

  return true;
};